import * as React from 'react';
import Layout from "../../../Components/layouts";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ReportServices } from '../../../Services/ReportServices';
import CustomTabs from '../../../Components/CustomTabs';
import {
    RespondentDigitalTalentMaturityColumn,
} from '../../../utils/constants';
import commonStyles from 'theme/commonStyles';
import { useJsonToCsv } from 'react-json-csv';
import { notify } from 'utils';
import jsPDF from 'jspdf';
import GaugeDashboard from '../component/DigitalMaturityInsights/dynamicReport';
import DetailsAnalyticsTabData from '../component/DigitalMaturityInsights/DyanmicTable';

const reportServices = new ReportServices();

const useStyles = makeStyles((theme) => ({
    contentWrapper: {
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.5),
        },
    },
}));

const DigitalTalentMaturity = () => {
    const commonClasses = commonStyles();
    const classes = useStyles();
    const theme = useTheme();
    const { saveAsCsv } = useJsonToCsv();

    const [score, setScore] = React.useState(0);
    const [allwords, setAllwords] = React.useState({});
    const [status, setStatus] = React.useState('Loading...');
    const [userList, setUserList] = React.useState([]);
    const [analyticsFilterState, setAnalyticsFilterState] = React.useState({
        users: [],
        customer: [],
        project: [],
        pageno: 0,
        perpage: 10
    });
    const [customerFiltersVal, setCustomerFiltersVal] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [projectsReportData, setProjectsReportData] = React.useState([]);
    const [filters, setFilters] = React.useState({
        users: [],
        customer: [],
        project: [],
        pagination: {
            previous_page: null,
            is_previous_page: false,
            next_page: null,
            is_next_page: false,
            start_index: 0,
            end_index: 0,
            total_entries: 0,
            total_pages: 0,
            page: 1,
        }
    });
    const [downloadReportLoading, setDownloadReportLoading] = React.useState(false);
    const [printReportLoading, setPrintReportLoading] = React.useState(false);

    const getProjectReportData = async (updatedFilter = analyticsFilterState) => {
         setLoading(true);

    const params = new URLSearchParams();

    // Map to value for API
    const customerValues = (updatedFilter.customer || []).map(c => c.value);
    const projectValues = (updatedFilter.project || []).map(p => p.value);
    const userValues = (updatedFilter.users || []).map(u => u.value);

    if (customerValues.length) params.append('company_name', customerValues.join(','));
    if (projectValues.length) params.append('project', projectValues.join(','));
    if (userValues.length) params.append('email', userValues.join(','));
    params.append('page', updatedFilter.pageno + 1);
    params.append('limit', updatedFilter.perpage);

    let result = await reportServices.getDataTalentMaturityModelData(
        `main/user-survey-averages?${params.toString()}`
    );

        if (result && result.status) {
            setFilters({
                ...result.data.filter,
                pagination: result.data.pagination
            });
            setProjectsReportData(result.data.results || []);
        } else {
            setFilters({
                users: [],
                customer: [],
                project: [],
                pagination: {
                    previous_page: null,
                    is_previous_page: false,
                    next_page: null,
                    is_next_page: false,
                    start_index: 0,
                    end_index: 0,
                    total_entries: 0,
                    total_pages: 0,
                    page: 1,
                }
            });
            setProjectsReportData([]);
        }
        setLoading(false);
    };

    React.useEffect(() => {
        getProjectReportData();
        // eslint-disable-next-line
    }, []);

    const getCustomerDimension = async (obj) => {
        obj.dimention = 'customer_dimension';
        let result = await reportServices.getDrarePortaData(`main/drareportdata`, obj);
        if (result && result.status) {
            let data = result.data;
            setScore(data.count || 0);
            setStatus(data.lst_variable || '');
            setAllwords(data.all_words);
        }
    };

    const handlePageChange = (page) => {
        setAnalyticsFilterState({ ...analyticsFilterState, pageno: page - 1 });
        getProjectReportData({ ...analyticsFilterState, pageno: page - 1 });
    };

    const handleChange = (val, type) => {
        setAnalyticsFilterState({ ...analyticsFilterState, [type]: val });
        getProjectReportData({ ...analyticsFilterState, [type]: val, pageno: 0 });
    };

    const handleUserChange = (val) => {
        setCustomerFiltersVal(val);
    };

    const handleUserSubmitFilter = () => {
        getCustomerDimension({ users: customerFiltersVal.map(itm => itm.value) });
    };

  const handleDownload = async () => {
    let fields = {};
    let columns = RespondentDigitalTalentMaturityColumn;
    // Transform filters for API
    let reportFilter = {
        ...analyticsFilterState,
        customer: (analyticsFilterState.customer || []).map(c => c.value),
        project: (analyticsFilterState.project || []).map(p => p.value),
        users: (analyticsFilterState.users || []).map(u => u.value),
        perpage: 99999,
        pageno: 0
    };
    columns.forEach((itm) => {
        fields[itm.key] = itm.label;
    });
    setDownloadReportLoading(true);
    let result = await reportServices.getDownloadCsvReportData(`main/download-user-survey-averages`, reportFilter);
    if (result && result.status && result?.data?.data) {
        saveAsCsv({ data: result.data.data, fields, filename: 'dtmreportdata' });
    } else {
        notify('error', "Report data not found!");
    }
    setDownloadReportLoading(false);
};

const handlePrint = async () => {
    // Transform filters for API
    let reportFilter = {
        ...analyticsFilterState,
        customer: (analyticsFilterState.customer || []).map(c => c.value),
        project: (analyticsFilterState.project || []).map(p => p.value),
        users: (analyticsFilterState.users || []).map(u => u.value),
        pageno: 0,
        perpage: 999999
    };
    setPrintReportLoading(true);

    if (!reportFilter.customer?.length) {
        notify('error', "Please select customer!");
        setPrintReportLoading(false);
        return;
    }

    try {
        const result = await reportServices.getDownloadCsvReportData(`main/download-user-survey-averages`, reportFilter);

        if (result && result.status && result?.data?.data) {
            const pdf = new jsPDF("p", "pt", "a3");

            const headers = [
                "Customer",
                "Project",
                "Name",
                "Surname",
                "Username",
                "Organizational Positioning",
                "Organizational Development",
                "Talent Readiness and Mobility",
                "Continuous Learning",
                "Transformative Environment",
                "Intelligent Harmony"
            ];

            const rows = result.data.data.map(item => [
                item.company_name || 'N/A',
                item.project || 'N/A',
                item.firstname || 'N/A',
                item.lastname || 'N/A',
                item.email || 'N/A',
                item.g1_average || 'N/A',
                item.g2_average || 'N/A',
                item.g3_average || 'N/A',
                item.g4_average || 'N/A',
                item.g5_average || 'N/A',
                item.g6_average || 'N/A',
            ]);

            pdf.autoTable({
                head: [headers],
                body: rows,
                startY: 65,
                theme: "grid",
                styles: { fontSize: 8 }
            });

            pdf.save('DigitalTalentMaturityReport.pdf');
        } else {
            notify('error', "Report data not found!");
        }
    } catch (error) {
        notify('error', "Something went wrong while generating the PDF!");
        console.error(error);
    }

    setPrintReportLoading(false);
};

    return (
        <Layout>
            <main>
                <div className={`${commonClasses.contentWrapper} ${classes.contentWrapper}`}>
                    <CustomTabs
                        disableSwipe
                        tabs={[
                            {
                                label: 'Respondents',
                                children: (
                                    <DetailsAnalyticsTabData
                                        type='respondant'
                                        title="Digital Talent Maturity Model Assessment"
                                       filters={{
        ...filters,
        users: filters.users?.map(u => ({ label: u, value: u })) || [],
        customer: filters.customer?.map(c => ({ label: c, value: c })) || [],
        project: filters.project?.map(p => ({ label: p, value: p })) || [],
    }}
                                        allFilterState={analyticsFilterState}
                                        handleChange={handleChange}
                                        columns={RespondentDigitalTalentMaturityColumn}
                                        loading={loading}
                                        list={projectsReportData}
                                        handlePageChange={handlePageChange}
                                        handleDownload={handleDownload}
                                        handlePrint={handlePrint}
                                        pageName="readline"
                                        noDataMessage="No record found"
                                    />
                                )
                            },
                            {
                                label: 'Insights',
                                children: (
                                    <GaugeDashboard />
                                )
                            },
                        ]}
                    />
                </div>
            </main>
        </Layout>
    );
};

export default DigitalTalentMaturity;